<template>
  <game></game>
</template>

<script>
import game from '@/components/game'
export default {
  components: {
    game
  }
}
</script>

<style>
</style>
